export default __webpack_public_path__ + "static/media/2 - Garden Martians.7e93be42.jpg";